class BlockTrendLineCompare extends HTMLElement {
  data = undefined;
  isBuilt = false;
  main = undefined;
  svgWidth = 602;
  graphHeight = 190;
  ns = 'http://www.w3.org/2000/svg';

  constructor() {
    super();
  }

  connectedCallback() {
    if (!this.isBuilt) {
      this.main = this.querySelector('[data-main]');
      this.build();
      this.isBuilt = true;
      this.dispatchEvent(new Event('built'));
    }
  }

  static get observedAttributes() {
    return ['data-settings', 'animate'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'data-settings') {
      this.data = JSON.parse(newValue);
    }
    if (name === 'animate') {
      this.animte = newValue === '1';
    }
  }

  build() {
    const segWidth = this.svgWidth / this.data.line1.segments.length;
    let points = [];
    let x;
    let y;
    let point;
    let textY;
    //
    const lineContainer = this.createSVG(this.svgWidth, this.graphHeight, 'graph');
    const titleContainer = this.createSVG(this.svgWidth, 34, 'titles');
    //
    const line = document.createElementNS(this.ns, 'line');
    line.setAttributeNS(null, 'x1', '0');
    line.setAttributeNS(null, 'y1', '0');
    line.setAttributeNS(null, 'x2', '602');
    line.setAttributeNS(null, 'y2', '0');
    line.setAttributeNS(null, 'stroke-width', '1');
    titleContainer.appendChild(line);
    //
    this.data.line1.segments.forEach((segment, i) => {
      x = ((i + 1) * segWidth) - (segWidth / 2);
      y = this.graphHeight - ((segment.value / 100) * this.graphHeight);
      textY = segment.position === 'above' ? y - 12 : y + 28;
      point = [x, y];
      points.push(point);
      lineContainer.appendChild(this.createSVGText(segment.text, x, textY, 'middle', 'line-1'));
      titleContainer.appendChild(this.createSVGText(segment.title, x, 21,' middle'))
    });
    //
    lineContainer.appendChild(this.createPolyline(points, this.data.line1.lineName, 'line-1'));
    points = [];
    //
    this.data.line2.segments.forEach((segment, i) => {
      x = ((i + 1) * segWidth) - (segWidth / 2);
      y = this.graphHeight - ((segment.value / 100) * this.graphHeight);
      textY = segment.position === 'above' ? y - 12 : y + 28;
      point = [x, y];
      points.push(point);
      lineContainer.appendChild(this.createSVGText(segment.text, x, textY, 'middle', 'line-2'));
    });
    //
    lineContainer.appendChild(this.createPolyline(points, this.data.line2.lineName, 'line-2'));
    this.main.append(lineContainer, titleContainer);
  }

  createSVG(width, height, className) {
    const svg = document.createElementNS(this.ns, 'svg');
    svg.setAttributeNS(null, 'viewBox', `0 0 ${width} ${height}`);
    svg.setAttribute('xmlns', this.ns);
    svg.setAttributeNS(null, 'version', '1.1');
    svg.setAttribute('xmlns:xlink', 'http://www.w3.org/1999/xlink');
    svg.classList.add(className);
    return svg;
  }

  createSVGText(string, x, y, anchor, className) {
    const text = document.createElementNS(this.ns, 'text');
    text.setAttributeNS(null, 'x', x);
    text.setAttributeNS(null, 'y', y);
    text.setAttributeNS(null, 'text-anchor', anchor);
    const tspan = document.createElementNS(this.ns, 'tspan');
    tspan.innerHTML = string;
    tspan.setAttributeNS(null, 'dy', '0');
    tspan.setAttributeNS(null, 'x', x);
    text.appendChild(tspan);
    text.classList.add(className);
    return text;
  }

  createPolyline(points, title, className) {
    const polyline = document.createElementNS(this.ns, 'polyline');
    polyline.setAttributeNS(null, 'points', points.join(' '));
    polyline.setAttributeNS(null, 'fill', 'none');
    polyline.setAttributeNS(null, 'stroke-linejoin', 'miter');
    polyline.setAttributeNS(null, 'stroke-linecap', 'round');
    polyline.setAttributeNS(null, 'stroke-width', '6');
    const titleEl = document.createElementNS(this.ns, 'title');
    titleEl.innerHTML = title;
    polyline.appendChild(titleEl);
    polyline.classList.add(className);
    return polyline;
  }
}

customElements.define('block-trend-line-compare', BlockTrendLineCompare);